import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  OnDestroy
} from '@angular/core';
import { IDisplayData } from '@whetstoneeducation/hero-common';
import { IHeroEventListFilter } from '../hero-event-list-models/hero-event-list-filter.interface';
import { BaseComponent } from '../../../../shared/base-classes/base.component';
import { Subject, takeUntil } from 'rxjs';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
  selector: 'app-hero-event-list-filters',
  templateUrl: './hero-event-list-filters.component.html',
  styleUrls: ['./hero-event-list-filters.component.scss']
})
export class HeroEventListFiltersComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  @Input() filters: IHeroEventListFilter;
  @Input() eventCategoryOptions: IDisplayData[];
  @Output() filtersUpdated = new EventEmitter<IHeroEventListFilter>();
  public searchControl = new FormControl('');

  private destroy$ = new Subject<void>();

  constructor() {
    super();
  }

  public ngOnInit() {
    this.searchControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (searchValue: string) => {
        this.filters.search = searchValue;
        this.filtersUpdated.emit(this.filters);
      });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public onFilterChange(event: number, filter: string) {
    this.filters[filter] = event;
    this.filtersUpdated.emit(this.filters);
  }
}
